import wavingHandIcon from 'shared/icons/waving-hand.svg';

import styles from './style.module.scss';

export const WaveHandIcon = () => (
  <img className={styles.icon} src={wavingHandIcon} alt="waving hand" />
);
